import { Typography } from "@clockwise/design-system";
import { Link } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
// styles
import classnames from "classnames";
import * as React from "react";
import { colors } from "../../styles/color.styles";

export interface CwLinkBaseProps {
  children: any;
  className?: string;
  size?: 13 | 14;
}

interface CwOnClickLinkProps extends CwLinkBaseProps {
  onClick: (e: React.MouseEvent<HTMLAnchorElement>) => unknown;
  href?: never;
}

interface CwHrefLinkProps extends CwLinkBaseProps {
  onClick?: never;
  href: string;
}

export type CwLinkProps = CwOnClickLinkProps | CwHrefLinkProps;

const useStyles = makeStyles({
  bold: {
    fontWeight: "bold",
  },
  link: {
    cursor: "pointer",
  },
  content: {
    color: colors.green.darker,
    fontWeight: 700,

    "&.size_13": {
      fontSize: 13,
    },
    "&.size_14": {
      fontSize: 14,
    },
  },
});

export const CwLink = ({ onClick, href, children, className, size = 13 }: CwLinkProps) => {
  const classes = useStyles();

  const _onClick = href ? () => window.open(href, "_blank") : onClick;

  return (
    <Link underline="none" className={classnames([classes.link, className])} onClick={_onClick}>
      <Typography className={classnames([classes.content, `size_${size}`])}>{children}</Typography>
    </Link>
  );
};

// export const CwLink = ({ children, className, size = 13, href }: CwLinkHrefProps) => {
//   const classes = useStyles();

//   return (
//     <Link
//       underline="none"
//       className={classnames([classes.link, className])}
//       onClick={() => window.open(href, "_blank")}
//     >
//       <Typography className={classnames([classes.content, `size_${size}`])}>{children}</Typography>
//     </Link>
//   );
// };
